import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'
import { paginateArray, sortCompare } from '@/@fake-db/utils'
// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useTransactionsList() {
  // Use toast
  const toast = useToast()

  const refUserListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'fullName', label: 'Nom', sortable: true },
    { key: 'email', label: 'Email', sortable: true },
    { key: 'createdAt', label: 'Date', sortable: true },
    { key: 'montant', label: 'Montant', sortable: true },
    { key: 'pays', label: 'Pays', sortable: true },
    { key: 'status', sortable: true },
    { key: 'actions' },
  ]
  const perPage = ref(10)
  const totalUsers = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('createdAt')
  const isSortDirDesc = ref(true)

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    }
  })

  const refetchData = () => {
    refUserListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery], () => {
    refetchData()
  })

  const fetchTransactions = (ctx, callback) => {
    store
      .dispatch('app-transactions/getListTransactions', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then(response => {

        // console.log('response.data',response.data.data)
        let data = response.data.data.data.map(x => {
          return {
            date: x?.date,
            newdate:  new Date(x?.date),
            ...x
          }
        });

        // console.log('datadata', data)
        // data = data.filter(x => x?.client != null);
        // const transactions = data.map(x => {
        //  return {
        //     id: x?._id,
        //     fullName: (x?.client?.first_name ? x?.client?.first_name : 'Non') + " " + (x?.client?.last_name ? x?.client?.last_name : 'Défini'),
        //     email: x?.client?.email,
        //     date: x?.date,
        //     montant: x?.amount,
        //     pays: x?.client?.country,
        //     status: x?.status,
        //     reference: x?.reference,
        //     civilite: x?.client?.civilite,
        //     company: x?.client?.company,
        //     address: x?.client?.address,
        //     arriveContry: x?.client?.arriveContry,
        //     arriveVille: x?.client?.arriveVille,
        //     country: x?.client?.country,
        //     numberPiece: x?.client?.numberPiece,
        //     phone: x?.client?.phone,
        //     structure_client: x?.client?.structure_client,
        //     telephonewhatsapp: x?.client?.telephonewhatsapp,
        //     typePiece: x?.client?.typePiece,
        //     function_client: x?.client?.function_client,
        //     currentLocation: x?.client?.currentLocation,
        //     bookingHotel: x?.client?.bookingHotel,
        //   }
        // });

        // const sortedData = list.sort(sortCompare(sortBy))
        // if (sortDesc) sortedData.reverse()

        
        
        callback(data)
        totalUsers.value =  response.data.data.total
      })
      .catch((err) => {
        console.log(err)
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const fetchStats = (ctx, callback) => {
    store
      .dispatch('app-transactions/getListTransactions', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then(response => {

        // console.log('response.data',response.data.data)
        const data = response.data.data;
        const transactions = data.map(x => {
         return {
            fullName: x?.client?.first_name + " " + x?.client?.last_name,
            email: x?.client?.email,
            date: x?.date,
            montant: x?.amount,
            pays: x?.client?.country,
            status: x?.status,
          }
        });
        
        callback(transactions)
        totalUsers.value = transactions.length
      })
      .catch((err) => {
        console.log(err)
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserStatusVariant = status => {
    if (status === 'PENDING') return 'warning'
    if (status === 'COMPLETED') return 'success'
    if (status === 'CANCELED') return 'secondary'
    return 'primary'
  }

  const totalCotisation = cotisations => {
    const data = cotisations.map(x => x.montant);
    const initialValue = 0;
    const sumWithInitial = cotisations.reduce(
      (previousValue, currentValue) => previousValue + currentValue,
      initialValue
    );
    return sumWithInitial;
  }

  return {
    fetchTransactions,
    fetchStats,
    
    tableColumns,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,

    totalCotisation,
    resolveUserStatusVariant,
    refetchData,

  }
}
